// Local translations
export const T = {
  en_GB: {
    sectionVisibility: "Section Visibility",
    sectionVisibilityDesc:
      "Choose which sections to show. You can add multiple components to split sections across pages.",
    income: "Income",
    assets: "Assets",
    liabilities: "Liabilities",
    commitments: "Commitments",
    capacity: "Capacity",
    displayOptions: "Display Options",
    incomeStabilityQuestion: "Income Stability Question",
    incomeStabilityDesc: "Ask about income stability",
    expectingChangesQuestion: "Expected Changes Question",
    expectingChangesDesc: "Ask whether the client expects changes; keep on one component only",
    capacityForLoss: "Capacity for Loss",
    capacityForLossDesc: "Auto-calculate capacity classification",
    summaryMetrics: "Summary Metrics",
    summaryMetricsDesc: "Show net worth, debt ratio, etc.",
    note: "Note",
    financialSituationNote:
      "Field definitions are configured in the Financial Situation Model assigned to this flow. Go to Flow Settings to select or change the model.",
  },
  nb_NO: {
    sectionVisibility: "Seksjonssynlighet",
    sectionVisibilityDesc:
      "Velg hvilke seksjoner som skal vises. Du kan legge til flere komponenter for å fordele seksjoner på tvers av sider.",
    income: "Inntekt",
    assets: "Eiendeler",
    liabilities: "Gjeld",
    commitments: "Forpliktelser",
    capacity: "Kapasitet",
    displayOptions: "Visningsalternativer",
    incomeStabilityQuestion: "Spørsmål om inntektsstabilitet",
    incomeStabilityDesc: "Spør om inntektsstabilitet",
    expectingChangesQuestion: "Spørsmål om forventede endringer",
    expectingChangesDesc: "Spør om kunden forventer endringer; behold på kun én komponent",
    capacityForLoss: "Tapskapasitet",
    capacityForLossDesc: "Automatisk beregning av kapasitetsklassifisering",
    summaryMetrics: "Sammendragsmålinger",
    summaryMetricsDesc: "Vis nettoverdi, gjeldsgrad osv.",
    note: "Merknad",
    financialSituationNote:
      "Feltdefinisjoner konfigureres i Økonomisk situasjon-modellen som er tilordnet denne flyten. Gå til Flytinnstillinger for å velge eller endre modellen.",
  },
} as const;
